// export const API_BASE_URL = 'http://localhost:8080/back';
export const API_BASE_URL = `https://murmanclick.ru/back`;
